module.exports = __webpack_public_path__ + "assets/img/32_645.86d625e3.jpg";